// removed by extract-text-webpack-plugin
module.exports = {"root":"dd0a6401"};


//////////////////
// WEBPACK FOOTER
// ./src/components/VirtualVideoRoom/Components/MemberList/styles.styl
// module id = 5158
// module chunks = 39